var _rect, _rect2, _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 127,
    viewBox: "0 0 140 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.08789,
    width: 139,
    height: 125,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.08789,
    width: 139,
    height: 125,
    rx: 3.5,
    stroke: "var(--color-primary)",
    strokeDasharray: "6 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 63.5879,
    r: 50,
    fill: "#D9EBCC",
    fillOpacity: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.4489,
    cy: 49.6285,
    r: 14.0504,
    fill: "var(--color-primary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1641 83.2147C48.1603 82.2269 48.3812 81.2513 48.8101 80.3615C50.1559 77.6699 53.9512 76.2433 57.1004 75.5973C59.3716 75.1126 61.6742 74.7888 63.991 74.6283C68.2804 74.2515 72.5946 74.2515 76.884 74.6283C79.2006 74.7907 81.5031 75.1144 83.7747 75.5973C86.9239 76.2433 90.7191 77.5353 92.0649 80.3615C92.9274 82.1753 92.9274 84.281 92.0649 86.0947C90.7191 88.921 86.9239 90.213 83.7747 90.832C81.5061 91.3368 79.2027 91.6697 76.884 91.828C73.3928 92.1239 69.8853 92.1779 66.3866 91.9895C65.5791 91.9895 64.7985 91.9895 63.991 91.828C61.6811 91.6717 59.3864 91.3387 57.1273 90.832C53.9512 90.213 50.1828 88.921 48.8101 86.0947C48.3834 85.1946 48.1627 84.2108 48.1641 83.2147Z",
    fill: "var(--color-primary)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3643 89.4977C105.866 89.4977 111.111 94.609 111.111 100.883C111.111 107.157 105.866 112.268 99.3643 112.268C92.8628 112.268 87.618 107.157 87.618 100.883C87.618 94.609 92.8628 89.4977 99.3643 89.4977Z",
    fill: "#11643C",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.e787368f26bfa8960914e79590c1edf9.svg";
export { ForwardRef as ReactComponent };